import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function MenuDetail({menuItem, showImage}) {
  console.log(menuItem);
  return (
    <div className="menuItem">
      <Typography>
        {menuItem.description}
      </Typography>
    {menuItem.imageUrl && <br />}
    {menuItem.imageUrl && <Box component="img" src={menuItem.imageUrl} sx={{maxWidth:"90%"}} />}
    </div>
  );
}

export default MenuDetail;
